<div class="modal right" id="dayendDetail" tabindex="-1" role="dialog" aria-labelledby="dayendDetailLabel">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header bg-light hide-print">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
				<h4 class="modal-title fs18" id="dayendDetailLabel">Gün Sonu No : {{ data.dayend.id }}</h4>			
			</div>
	
			<div class="modal-body with-tab">
	
				<div class="loading" ng-if="loadingWork">
					<div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
				</div>
						
				<ul class="nav nav-tabs nav-justified" id="tabContent">
					<li class="active">
						<a target="_self" href="#dayendDetails" data-toggle="tab">Gün Sonu Detayları</a>
					</li>
					<li>
						<a target="_self" href="#items" data-toggle="tab">Gün Sonu Hareketleri</a>
					</li>
					<li>
						<a target="_self" href="#orders" data-toggle="tab">Kargolar</a>
					</li>
				</ul>

				<div class="tab-content">
					<div class="tab-pane active" id="dayendDetails">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<div class="panel-body mt10">
										<div class="col-md-7">
											<p>
												<strong>Gün : </strong>
												<span>{{ data.dayend.date }}</span>
											</p>
											<p>
												<strong>Personel : </strong>
												<span>{{ data.dayend.worker.full_name }}</span>
											</p>
											<p>
												<strong>Toplam Ücret : </strong>
												<span>{{ data.dayend.total_price }}</span>
											</p>
											<p>
												<strong>Kalan Ücret : </strong>
												<span>{{ data.dayend.remaining_price }}</span>
											</p>
										</div>
										<div class="col-md-5">
											<a href="#" class="btn btn-block btn-primary" ng-click="completeDayend(data.dayend)" ng-if="data.dayend.status == 0">Gün Sonunu Onayla</a>
											<a href="#" class="btn btn-block btn-danger" ng-click="unCompleteDayend(data.dayend)" ng-if="data.dayend.status == 1">Onayı Geri Al</a>
											<a href="#" ng-if="data.dayend.status == 1">Gün Sonunu Onaylanmıştır.</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tab-pane" id="items">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<table class="table table-hover tc-checkbox-1 fs13" ng-if="data.dayend.items.length > 0">
										<thead>
											<tr class="bg-light">
												<th>
													<a href="#" ng-click="sortType = 'id'; sortReverse = !sortReverse">
													Hareket NO
													<span ng-show="sortType == 'id' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'id' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<!-- <th>
													<a href="#" ng-click="sortType = 'worker.full_name'; sortReverse = !sortReverse">
													Personel
													<span ng-show="sortType == 'worker.full_name' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'worker.full_name' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th> -->
												<th>
													<a href="#" ng-click="sortType = 'order_id'; sortReverse = !sortReverse">
													Ücret
													<span ng-show="sortType == 'order_id' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'order_id' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'order_id'; sortReverse = !sortReverse">
													Kanıt/Resim
													<span ng-show="sortType == 'order_id' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'order_id' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'create_at'; sortReverse = !sortReverse">
													Hareket Zamanı
													<span ng-show="sortType == 'create_at' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'create_at' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
											</tr>
										</thead>
										<tbody>
										<tr ng-repeat="item in data.dayend.items | orderBy:sortType:sortReverse">
											<td class="text-left">#{{item.id}}</td>
											<!-- <td class="">{{ item.worker.full_name }} </td> -->
											<td class="">{{ item.price }} </td>
											<td class="">
												<a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.image }}" target="__BLANK" ng-if="item.image.length > 0" >
													<img
														ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.image }}" 
														class="img-thumbnail" width="150px">
												</a>
											</td>
											<td class="">{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
										</tr>
										</tbody>
									</table>

									<div ng-if="data.dayend.items.length == 0">
										Bu Gün sonuna ait bir hareket henüz oluşturulmamıştır.
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tab-pane" id="orders">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<a href="#" class="btn btn-success pull-right mb10 fs14" ng-click="downloadExcelDayend()">Dışa Aktar</a>
									<table class="table table-hover tc-checkbox-1 fs13" ng-if="data.dayend.orders.length > 0">
										<thead>
											<tr class="bg-light">
												<th>Kargo NO</th>
												<th>Ödeme Tutarı</th>
											</tr>
										</thead>
										<tbody>
										<tr ng-repeat="item in data.dayend.orders | orderBy:sortType:sortReverse">
											<td class="text-left">#{{item.id}}</td>
											<td class="">{{ item.price }} </td>
										</tr>
										</tbody>
									</table>

									<div ng-if="data.dayend.items.length == 0">
										Bu Gün sonuna ait bir kargo bulunmamaktadır.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div class="modal-footer bg-light hide-print">
				<button type="button" class="btn btn-default" data-dismiss="modal">Kapat</button>
				<!-- <a href="stok/urun/{{ data.dayend.id }}" class="btn btn-warning">Düzenle</a> -->
			</div>
		</div>
	</div>
</div>
<style>
	html, body {
	height: 100%;
	}
</style>